import HttpService from "./htttp.service";

class BudgetService {
  // Budget Dashboard APIs
  createOrGetBudget = async (userId, yearMonth, currencyCode, startDate, endDate) => {
    const endpoint = `users/${userId}/budgets`;
    const payload = { 
      yearMonth,
      currencyCode,
      startDate,
      endDate
    };
    return await HttpService.post(endpoint, payload);
  };

  getBudgetItems = async (budgetId) => {
    const endpoint = `budgets/${budgetId}/items`;
    return await HttpService.get(endpoint);
  };

  createBudgetItem = async (budgetId, name, amount, type, itemId) => {
    const endpoint = `budgets/${budgetId}/items`;
    const payload = {
      id: itemId,
      name,
      amount,
      type
    };
    return await HttpService.post(endpoint, payload);
  };

  updateBudgetItem = async (budgetId, itemId, name, amount) => {
    const endpoint = `budgets/${budgetId}/items/${itemId}`;
    const payload = {
      name,
      amount
    };
    return await HttpService.put(endpoint, payload);
  };

  deleteBudgetItem = async (budgetId, itemId) => {
    const endpoint = `budgets/${budgetId}/items/${itemId}`;
    return await HttpService.delete(endpoint);
  };

  updateBudgetOverview = async (budgetId, overview) => {
    const endpoint = `budgets/${budgetId}/overview`;
    const payload = {
      rollover: overview.rollover || 0,
      actualRollover: overview.actualRollover || 0,
      income: overview.income || 0,
      expenses: overview.expenses || 0,
      bills: overview.bills || 0,
      savings: overview.savings || 0,
      investing: overview.investing || 0,
      debts: overview.debts || 0
    };
    return await HttpService.post(endpoint, payload);
  };

  updateBudget = async (userId, budgetId, currencyCode, startDate, endDate) => {
    const endpoint = `users/${userId}/budgets/${budgetId}`;
    const payload = {
      currencyCode,
      startDate,
      endDate
    };
    return await HttpService.put(endpoint, payload);
  };
}

export default new BudgetService(); 